/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import AnalyticsUtil from '../../utils/AnalyticsUtil';
import LibrariesUtil from '../../utils/LibrariesUtil';

export default class LibrariesAnalytics {
	ingest: ingestObject;
	analyticsUtils: AnalyticsUtil;

	constructor() {
		this.analyticsUtils = new AnalyticsUtil();
		this.ingest = this.analyticsUtils.ingest;
	}

	/**
	 * [initAnalytics Init Ingest]
	 * @returns {[none]}
	 */
	initAnalytics() {
		this.ingest.initializeDefaultData();
	}

	/**
	 * [logAnalytics A utility method to set multiple values at once]
	 * @param  {[object of key/value pairs]} dataObject [events]
	 * @returns {[none]}
	 */
	logAnalytics(analyticsObj: Object) {
		/* istanbul ignore next */
		const dataObject: dataObject = {};
		if (analyticsObj) {
			if (analyticsObj['event.type']) {
				dataObject.setEventType = analyticsObj['event.type'];
			}
			if (analyticsObj['event.subtype']) {
				dataObject.setEventSubtype = analyticsObj['event.subtype'];
			}
			if (analyticsObj['event.value']) {
				dataObject.setEventValue = analyticsObj['event.value'];
			}
			if (analyticsObj['event.subcategory']) {
				dataObject.setEventSubcategory = analyticsObj['event.subcategory'];
			}
			if (analyticsObj['content.id']) {
				dataObject.setContentID = analyticsObj['content.id'];
			}
			if (analyticsObj['content.name']) {
				dataObject.setContentName = analyticsObj['content.name'];
			}
			if (analyticsObj['content.author']) {
				dataObject.setContentAuthor = analyticsObj['content.author'];
			}
			if (analyticsObj['content.action']) {
				dataObject.setContentAction = LibrariesUtil.getExternalLink(analyticsObj['content.action']);
			}
			if (analyticsObj['content.type']) {
				dataObject.setContentType = analyticsObj['content.type'];
			}
			if (analyticsObj['ui.view_type']) {
				dataObject.setUIViewType = analyticsObj['ui.view_type'];
			}
			if (analyticsObj['event.error_type']) {
				dataObject.setEventErrorType = analyticsObj['event.error_type'];
			}
			if (analyticsObj['event.error_desc']) {
				dataObject.setEventErrorDesc = analyticsObj['event.error_desc'];
			}
			const productName = LibrariesUtil.extractQueryParamValue(location.href, 'x-product');
			const productComponent = LibrariesUtil.extractQueryParamValue(location.href, 'x-product-location');
			if (productName || productComponent) {
				dataObject.setEnvironmentComponentName = `${productName}:${productComponent}`;
			}
			dataObject.setEventWorkFlow = 'Libraries';
		}
		this.analyticsUtils.logAnalytics(dataObject);
	}

	/**
	 * [sendToIngest Post to ingest]
	 * @returns {[none]}
	 */
	sendToIngest() {
		// this.analyticsUtils.checkOptin(this.ingest);
		this.analyticsUtils.checkOptin(this.ingest);
	}

	sendLibrariesAnalytics(analyticsObj) {
		this.initAnalytics();
		this.logAnalytics(analyticsObj);
		this.sendToIngest();
	}
}
